import apiService, { HTTP_STATUS, isSuccess, isCreated } from 'util/apiService';
import {
  CLEAR_SITE_LOCATION_ALERT,
  GET_DEFAULT_SITE_INFO_FAILURE,
  GET_DEFAULT_SITE_INFO_START,
  GET_DEFAULT_SITE_INFO_SUCCESS,
  GET_SITE_INFO_FAILURE,
  GET_SITE_INFO_START,
  GET_SITE_INFO_SUCCESS,
  SET_SITE_INFO_FAILURE,
  SET_SITE_INFO_START,
  SET_SITE_INFO_SUCCESS,
  SET_SITE_INFO_SELECTED,
} from './constants';
import {getUserConfig} from "modules/cbre-flow-api-ducks";
import { setCommonAlerts } from 'modules/cbre-flow-Common/actions';
import { RequestAccessUrl } from './selectors';



export const getSiteInfoStart = (payload) => ({
  type: GET_SITE_INFO_START,
  payload,
});

export const getSiteInfoSuccess = (payload) => ({
  type: GET_SITE_INFO_SUCCESS,
  payload,
});

export const getSiteInfoFailure = (payload) => ({
  type: GET_SITE_INFO_FAILURE,
  payload,
});

export const setSiteInfoStart = (payload) => ({
  type: SET_SITE_INFO_START,
  payload,
});

export const setSiteInfoSuccess = (payload) => ({
  type: SET_SITE_INFO_SUCCESS,
  payload,
});

export const setSiteInfoSelected = (payload) => ({
  type: SET_SITE_INFO_SELECTED,
  payload,
});

export const setSiteInfoFailure = (payload) => ({
  type: SET_SITE_INFO_FAILURE,
  payload,
});

export const getDefaultSiteListStart = (payload)=>({
  type: GET_DEFAULT_SITE_INFO_START,
  payload,
})

export const getDefaultSiteListSuccess = (payload) => ({
  type: GET_DEFAULT_SITE_INFO_SUCCESS,
  payload,
});

export const getDefaultSiteListFailure = (payload) => ({
  type: GET_DEFAULT_SITE_INFO_FAILURE,
  payload,
});

export const clearSiteLocationAlerts = (payload) => ({
  type: CLEAR_SITE_LOCATION_ALERT,
  payload,
});


export const getSiteInfo = (payload) => {
  const { apiUrl } = payload;

  return (dispatch) => {
    // eslint-disable-next-line no-unused-expressions
    payload.errorDetails ? dispatch(getSiteInfoStart(payload.errorDetails))
      : dispatch(getSiteInfoStart());
    return apiService
      .get(apiUrl)
      .then((res) => {
        const {
          getSiteInfo:code, messageCode, data,
        } = res;
        if (code === HTTP_STATUS.OK) {
          dispatch(getSiteInfoSuccess(data));
        } else {
          dispatch(getSiteInfoFailure(messageCode));
        }
      })
      .catch((err) => {
        dispatch(getSiteInfoFailure({ messageCode: err.message }));
      });
  };
};

export const setSiteInfo = (payload) => {
  const { apiUrl, data, userUrl, redirectUrl, history, callback } = payload;

  return (dispatch) => {
    // eslint-disable-next-line no-unused-expressions
    payload.errorDetails ? dispatch(setSiteInfoStart(payload.errorDetails))
      : dispatch(setSiteInfoStart());
    return apiService
      .put(apiUrl, data)
      .then(async (res) => {
        const {
          statusCode: code, messageCode, data,
        } = res;
        if (isSuccess(code)) {
          dispatch(setSiteInfoSuccess(data));
          dispatch(setCommonAlerts({ message: 'Site Info Updated Successfully', type: 'success' }))
          if(userUrl){
           await dispatch(getUserConfig({ apiUrl: `${userUrl}`, redirectUrl, history }))
          }
          if(callback){
            callback(true);
          }
          return res;
        } else {
          dispatch(setSiteInfoFailure(messageCode));
          dispatch(setCommonAlerts({ message: 'Site Info Update Failed', type: 'failure' }))
        }
        return res;
      })
      .catch((err) => {
        dispatch(setSiteInfoFailure({ messageCode: err.message }));
        dispatch(setCommonAlerts({ message: 'Site Info Update Failed', type: 'failure' }))
      });
  };
}
export const requestAccessAction = (payload) => {
  const { data, userUrl, redirectUrl, history, callback } = payload;

  return (dispatch, getState) => {
    // Get the API URL from the selector
    const apiUrl = RequestAccessUrl(getState());
    
    // Check if apiUrl is available
    if (!apiUrl) {
      dispatch(setSiteInfoFailure({ messageCode: 'API URL not configured' }));
      dispatch(setCommonAlerts({ message: 'Request access failed - API URL not configured', type: 'failure' }));
      return Promise.reject(new Error('API URL not configured'));
    }

    return apiService
      .post(apiUrl, data)
      .then((res) => {
        const {
          statusCode: code, messageCode, data,
        } = res;
        if (isSuccess(code) || isCreated(code)) {
          dispatch(setCommonAlerts({ message: 'Request access created successfully', type: 'success' }))
          if(userUrl){
            dispatch(getUserConfig({ apiUrl: `${userUrl}`, redirectUrl, history }))
          }
          if(callback){
            callback(true);
          }
        } else {
          dispatch(setSiteInfoFailure(messageCode));
          dispatch(setCommonAlerts({ message: 'Request access failed', type: 'failure' }))
        }
        return res;
      })
      .catch((err) => {
        dispatch(setSiteInfoFailure({ messageCode: err.message }));
        dispatch(setCommonAlerts({ message: 'Request access failed', type: 'failure' }))
      });
  };
}

export const getSiteList = (payload) => {
  const { apiUrl, callback } = payload;
  return (dispatch) => {
    dispatch(getDefaultSiteListStart());
    return apiService
      .get(apiUrl)
      .then((res) => {
        const { statusCode:code, messageCode, data } = res;
        if (code === HTTP_STATUS.OK) {
          dispatch(getDefaultSiteListSuccess(data.recordsList));
          if(callback) callback(data.recordsList);
          return data.recordsList;
        } else {
          dispatch(getDefaultSiteListFailure(messageCode));
          if(callback) callback([]);
          return [];
        }
      })
      .catch((err) => {
        dispatch(getDefaultSiteListFailure({ messageCode: err.message }));
        if(callback) callback([]);
      });
  };
};